import { AirlinesCodes } from 'src/types'

function getNameOfTheAirline(company: AirlinesCodes): string {
  switch (company) {
    case 'AD':
      return 'AZUL'
    case 'G3':
      return 'GOL'
    case 'LA':
      return 'LATAM'
    default:
      return company as string
  }
}

export default getNameOfTheAirline
